export default __webpack_public_path__ + "static/media/historial-prestaciones.31f1b41c.svg";